import { useTranslation } from 'react-i18next';
import BaseModalEventBunpimay from './BaseModalEventBunpimay';
import iconOops from "assets/images/eventBunpimay/oops.png"
import iconFaceSad from "assets/images/eventBunpimay/sad-face.png"
import headerPopup from "assets/images/eventBunpimay/headerPopupWin.png"

function ModalBunpimayPairingError({ show, message, onHide, ...otherProps }) {
	const { t } = useTranslation()
	return (
		<BaseModalEventBunpimay srcImgHeader={headerPopup} show={show} onHide={onHide} hideDecor={true}  {...otherProps}>
			<div className='modal-fail modal-win'>
				<img draggable="false" src={iconOops} className='icon-oops' />
				<img draggable="false" src={iconFaceSad} className='icon-sad-face' />
				<div className='modal-win-description'>
					{message}
				</div>
			</div>
		</BaseModalEventBunpimay>
	);
}

export default ModalBunpimayPairingError;